import { configureStore } from '@reduxjs/toolkit'

// Reducer
import abtestReducer from './slice/abtest'
import tokenReducer from './slice/token'
import userReducer from './slice/user'
import shopifyStoreReducer from './slice/shopifyStore'

export const store = configureStore({
  reducer: {
    abtest: abtestReducer,
    token: tokenReducer,
    user: userReducer,
    shopifyStore: shopifyStoreReducer
  }
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch